import { ICardTransaction } from '@/features/cards/store/models/card.model';
import {
  IColumnSetting,
  TColumnConfig,
  TRowType,
  getConfigKey,
  createMandatoryColumnConfig,
} from '@/ui-kit/table/table.model';

type TExtraColumnKeys = 'merchant' | 'mccLocal';
type TColumnKey = keyof ICardTransaction | TExtraColumnKeys;

export type TCardTransactionColumnConfig = TColumnConfig<TColumnKey>;

export const allColumnConfig = {
  publicToken: {
    isActive: true,
  },
  cardtransactionId: {
    isActive: true,
    children: { cardtransactionId: { isActive: true } },
  },
  authorizationIssuerTime: {
    isActive: true,
  },
  paymentId: {
    isActive: true,
  },
  paymentAmount: {
    isActive: true,
    children: { paymentLocalAmount: { isActive: true } },
  },
  paymentStatus: {
    isActive: true,
  },
  transactionSubType: {
    isActive: false,
  },
  paymentCountry: {
    isActive: false,
  },
  walletId: {
    isActive: true,
  },
  mccCode: {
    isActive: true,
    children: { mccCode: { isActive: true }, mccLocal: { isActive: true } },
  },
  merchantId: {
    isActive: false,
  },
  merchant: {
    isActive: true,
    children: { merchantName: { isActive: true }, merchantAddress: { isActive: true } },
  },
  merchantCategory: {
    isActive: false,
    children: {
      merchantCategory: { isActive: false },
      merchantCategoryGroup: { isActive: false },
      merchantCategoryType: { isActive: false },
    },
  },
  acquirerId: {
    isActive: false,
  },
  authorizationResponseCode: {
    isActive: false,
    children: {
      authorizationResponseCode: { isActive: false },
      authorizationMti: { isActive: false },
    },
  },
  authorizationNote: { isActive: false },
  posTerminalId: { isActive: false },
  posCardholderPresence: { isActive: false },
  posCardPresence: { isActive: false },
  panEntryMethod: { isActive: false },
  is3DS: {
    isActive: false,
    children: {
      is3DS: { isActive: false },
      '3dsExemptionType': { isActive: false },
    },
  },
} as const satisfies TCardTransactionColumnConfig;

export type TCardTransactionColumnKey = keyof typeof allColumnConfig;

export type TCardTransactionRowType = TRowType<TCardTransactionColumnKey>;

export type TCardTransactionColumnSetting = IColumnSetting<TColumnKey>;
export const getCardTransactionConfigKey = (config?: TCardTransactionColumnSetting, key?: TColumnKey) =>
  getConfigKey(config, key);

const optionalColumns: TCardTransactionColumnKey[] = ['publicToken'];
export const mandatoryColumnConfig = createMandatoryColumnConfig(
  allColumnConfig as TColumnConfig<TCardTransactionColumnKey>,
  optionalColumns,
);
